
export default function ProgressBar({
    currentStep,
    totalSteps,
    steps,
  }) {
    return (
        <div className="w-full px-4 py-6">
          <div className="flex justify-between mb-2">
            {steps.map((step) => (
              <div
                key={step.id}
                className={`${step.id <= currentStep ? "text-green-600" : "text-gray-400"} lex-1 text-center text-xs sm:text-sm`}
              >
                <div className="relative">
                  <div
                    className={`${step.id < currentStep ? "bg-green-600" :
                        step.id === currentStep ? "bg-blue-600" : "bg-gray-300"} w-8 h-8 sm:w-10 sm:h-10 mx-auto rounded-full flex items-center justify-center text-white font-semibold mb-1`}
                  >
                    {step.id < currentStep ? '✓' : step.id}
                  </div>
                  <span className="hidden sm:block">{step.label}</span>
                </div>
              </div>
            ))}
          </div>
          <div className="relative h-2 bg-gray-200 rounded-full overflow-hidden">
            <div
              className="absolute h-full bg-gradient-to-r from-blue-500 to-green-500 transition-all duration-300 ease-out"
              style={{ width: `${((currentStep - 1) / (totalSteps - 1)) * 100}%` }}
            />
          </div>
        </div>
    );
}
